import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const AddHomeComponent = React.lazy(() => import("../Components/RootComponents/AddHomeComponent"));
const AddHomePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <AddHomeComponent />
      </Suspense>
    </Fragment>
  );
};

export default AddHomePage;
